import { memo } from "react";
import { Grid } from "@material-ui/core";

import { Field } from "formik";
import TextField from "@/components/textField/textField";
import { useBlur } from "@/pages/demo/hooks/useBlur";
import { DataCy } from "@/dto";

interface ContactDetailsStepProps {
  shouldDisplayEmail: boolean;
}

const ContactDetailsStepComponent = ({ shouldDisplayEmail }: ContactDetailsStepProps) => {
  const { makeBlurTracking, makeDidBlur } = useBlur();

  return (
    <div className="mt-5 flex flex-col space-y-5">
      {shouldDisplayEmail && (
        <Grid item xs={12}>
          <Field
            component={TextField}
            label={"Email"}
            name={"email"}
            required
            autoComplete={"on"}
            onBlur={(value) => makeBlurTracking("email", value)}
            onBlurUnconditionally={(value) => makeDidBlur("email", value)}
            type={"email"}
            dataCy={DataCy.marketing.demoForm.personalInfoStep.emailInput}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <Field
          component={TextField}
          label={"Full Name"}
          name={"name"}
          required
          autoComplete={"on"}
          onBlur={(value) => makeBlurTracking("full_name", value)}
          onBlurUnconditionally={(value) => makeDidBlur("name", value)}
          dataCy={DataCy.marketing.demoForm.personalInfoStep.fullNameInput}
        />
      </Grid>
      <Grid item xs={12}>
        <Field
          component={TextField}
          label={"Phone"}
          name={"phone"}
          required
          autoComplete={"on"}
          onBlur={(value) => makeBlurTracking("phone", value)}
          onBlurUnconditionally={(value) => makeDidBlur("phone", value)}
          maxNumber={100_000_000_000_000_000}
          type={"tel"}
          inputProps={{ inputMode: "tel" }}
          dataCy={DataCy.marketing.demoForm.personalInfoStep.phone}
        />
      </Grid>
      <Grid item xs={12}>
        <Field
          component={TextField}
          label={"Number of Units"}
          name={"numberOfUnits"}
          required
          onBlur={(value) => makeBlurTracking("expected_number_of_units__c", value)}
          onBlurUnconditionally={(value) => makeDidBlur("numberOfUnits", value)}
          maxNumber={999_999}
          formatType="number"
          inputProps={{ inputMode: "numeric" }}
          type={"tel"}
          dataCy={DataCy.marketing.demoForm.personalInfoStep.numberOfUnitsInput}
        />
      </Grid>
    </div>
  );
};

export const ContactDetailsStep = memo(ContactDetailsStepComponent);
